import { render, staticRenderFns } from "./GenericTableIconCell.vue?vue&type=template&id=5e19c48e&scoped=true"
import script from "./GenericTableIconCell.vue?vue&type=script&lang=ts"
export * from "./GenericTableIconCell.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e19c48e",
  null
  
)

export default component.exports